 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~a2aedf79":"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~a2aedf79","app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~5f889d72":"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~5f889d72","app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~cb521681":"app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~cb521681","app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~28a6f7e5":"app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~28a6f7e5","app-banner":"app-banner","app-categories":"app-categories","bot-conversations":"bot-conversations","business-requests":"business-requests","customers":"customers","history-orders":"history-orders","invoice-payments":"invoice-payments","invoice-store":"invoice-store","invoices-due":"invoices-due","logs-store":"logs-store","notifications-massive":"notifications-massive","product-categories":"product-categories","products":"products","products-discount":"products-discount","promo-code-crud":"promo-code-crud","promo-code-uses":"promo-code-uses","push-sms":"push-sms","report-detail":"report-detail","reports-general":"reports-general","reports-store":"reports-store","rider-orders":"rider-orders","riders":"riders","settlements":"settlements","store-banners":"store-banners","stores":"stores","view-store":"view-store","zones":"zones","orders~orders-delivered":"orders~orders-delivered","orders":"orders","orders-delivered":"orders-delivered","stores-maps":"stores-maps","geo-coverage~riders-map":"geo-coverage~riders-map","geo-coverage":"geo-coverage","login":"login","schedule-config":"schedule-config","riders-map":"riders-map","invoice-print":"invoice-print"}[chunkId]||chunkId) + "." + {"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~a2aedf79":"62fdbcf1","app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~5f889d72":"708ab736","app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~cb521681":"17afb282","app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~28a6f7e5":"6477f763","app-banner":"95f02c57","app-categories":"234dbd6f","bot-conversations":"44e82678","business-requests":"88fb2131","customers":"04bfc9f7","history-orders":"2fea53fa","invoice-payments":"7a1268d1","invoice-store":"eaafb98c","invoices-due":"8780594e","logs-store":"5675d3c0","notifications-massive":"9d05d5b3","product-categories":"a52a2206","products":"cb6ffb3c","products-discount":"a4bb00ff","promo-code-crud":"dd259d03","promo-code-uses":"12861938","push-sms":"3b91aec8","report-detail":"f4d3b9fe","reports-general":"30f2a0f3","reports-store":"c6d2adf0","rider-orders":"d5614446","riders":"5dcf83e7","settlements":"0805871f","store-banners":"4e0bc0ec","stores":"7e6d7b23","view-store":"535868ab","zones":"78a06c37","orders~orders-delivered":"01d23cbb","orders":"a7b1b816","orders-delivered":"f4507248","stores-maps":"d6d53214","geo-coverage~riders-map":"51778465","geo-coverage":"29dda6c8","login":"bc350336","schedule-config":"0dbf67fb","riders-map":"4cf7d66c","invoice-print":"3d9c7b40"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~a2aedf79":1,"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~5f889d72":1,"app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~cb521681":1,"app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~28a6f7e5":1,"app-banner":1,"app-categories":1,"bot-conversations":1,"business-requests":1,"customers":1,"history-orders":1,"invoice-store":1,"invoices-due":1,"logs-store":1,"notifications-massive":1,"product-categories":1,"products":1,"products-discount":1,"promo-code-crud":1,"promo-code-uses":1,"reports-general":1,"rider-orders":1,"riders":1,"settlements":1,"store-banners":1,"stores":1,"view-store":1,"zones":1,"orders~orders-delivered":1,"orders":1,"orders-delivered":1,"stores-maps":1,"geo-coverage":1,"login":1,"schedule-config":1,"riders-map":1,"invoice-print":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~a2aedf79":"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~a2aedf79","app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~5f889d72":"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~5f889d72","app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~cb521681":"app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~cb521681","app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~28a6f7e5":"app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~28a6f7e5","app-banner":"app-banner","app-categories":"app-categories","bot-conversations":"bot-conversations","business-requests":"business-requests","customers":"customers","history-orders":"history-orders","invoice-payments":"invoice-payments","invoice-store":"invoice-store","invoices-due":"invoices-due","logs-store":"logs-store","notifications-massive":"notifications-massive","product-categories":"product-categories","products":"products","products-discount":"products-discount","promo-code-crud":"promo-code-crud","promo-code-uses":"promo-code-uses","push-sms":"push-sms","report-detail":"report-detail","reports-general":"reports-general","reports-store":"reports-store","rider-orders":"rider-orders","riders":"riders","settlements":"settlements","store-banners":"store-banners","stores":"stores","view-store":"view-store","zones":"zones","orders~orders-delivered":"orders~orders-delivered","orders":"orders","orders-delivered":"orders-delivered","stores-maps":"stores-maps","geo-coverage~riders-map":"geo-coverage~riders-map","geo-coverage":"geo-coverage","login":"login","schedule-config":"schedule-config","riders-map":"riders-map","invoice-print":"invoice-print"}[chunkId]||chunkId) + "." + {"app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~a2aedf79":"cb3ede89","app-banner~app-categories~bot-conversations~business-requests~customers~geo-coverage~history-orders~~5f889d72":"3979d6b8","app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~cb521681":"7cdfc5ad","app-banner~app-categories~bot-conversations~business-requests~customers~history-orders~invoice-payme~28a6f7e5":"dc4a31b7","app-banner":"aee217b4","app-categories":"935786ef","bot-conversations":"d07bb0b7","business-requests":"ddad1e61","customers":"7cad4798","history-orders":"42c1337f","invoice-payments":"31d6cfe0","invoice-store":"6c2b6062","invoices-due":"469df479","logs-store":"7cad4798","notifications-massive":"ab9b1a44","product-categories":"35b50221","products":"5fc8f33c","products-discount":"ebbf9333","promo-code-crud":"ce8531a8","promo-code-uses":"c7105600","push-sms":"31d6cfe0","report-detail":"31d6cfe0","reports-general":"981130b2","reports-store":"31d6cfe0","rider-orders":"c7105600","riders":"981130b2","settlements":"6c63a1ad","store-banners":"aee217b4","stores":"9e9581f9","view-store":"fad2d45c","zones":"aee217b4","orders~orders-delivered":"0375b07e","orders":"76bbb783","orders-delivered":"84e563e9","stores-maps":"41aff8d4","geo-coverage~riders-map":"31d6cfe0","geo-coverage":"cf884a61","login":"a5472df3","schedule-config":"0f3525ab","riders-map":"0ccb04eb","invoice-print":"c196da86"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonp"] = this["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
